import { Injectable, } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseApiService } from './base-api.service';
import { SupplierModel } from './../models';


@Injectable()
export class SupplierService extends BaseApiService {

    getSuppliersByTerm(term: string): Observable<SupplierModel[]> {
        this.suspendSpinner = true;
        return this.get<SupplierModel[]>(`/api/suppliers?s=${encodeURIComponent(term)}&limit=8`);
    }

    getSuppliersByIds(ids: string[]): Observable<SupplierModel[]> {
        if (!ids || ids.length === 0) {
            return Observable.of(null);
        }
        const str = ids.reduce((a, b) => a + ',' + b);
        return this.get<SupplierModel[]>(`/api/suppliers?ids=${encodeURIComponent(str)}&limit=8`);
    }

    getSupplierById(id: number): Observable<SupplierModel> {
        return this.get<SupplierModel>(`/api/supplier/${id}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/supplier.service.ts